/* Copyright (c) 2015 Hyunje Alex Jun and other contributors
 * Licensed under the MIT License
 */
'use strict';

module.exports = require('./src/js/main');



/*****************
 ** WEBPACK FOOTER
 ** ./~/perfect-scrollbar/index.js
 ** module id = 789
 ** module chunks = 73
 **/